import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const level6: LevelConfig = {
  grid: [
    padRow(
      [
        { track: 'WE', exit: 'W' },
        'WE',
        'WE',
        'WE',
        'WE',
        'WE',
        ['WE', 'SW'],
        'WE',
        { track: 'WE', vehicle: { type: 'locomotive', direction: -1 } },
        'E',
      ],
      'prepend',
    ),
    padRow(['NS'], 'prepend', false, 16),
    padRow(
      [
        'W',
        { track: 'WE', vehicle: { type: 'wagon', color: 'forestgreen' } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'lawngreen' } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'blue' } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'purple' } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'red' } },
        'NW',
      ],
      'prepend',
      false,
    ),
  ],
  goal: {
    sequence: ['lawngreen', 'forestgreen', 'blue', 'red', 'purple'],
  },
}

// L shape
// export const level6: LevelConfig = {
//   grid: [
//     padRow(
//       [{ track: 'WE', exit: 'W' }, 'WE', 'WE', 'WE', 'WE', 'WE', ['SW', 'WE'], 'WE', 'WE', 'E'],
//       'prepend',
//     ),
//     padRow([{ track: 'NS', vehicle: { type: 'locomotive', direction: -1 } }], 'prepend', false, 16),
//     padRow(
//       [{ track: 'NS', vehicle: { type: 'wagon', color: 'red', direction: -1 } }],
//       'prepend',
//       false,
//       16,
//     ),
//     padRow(
//       [{ track: 'NS', vehicle: { type: 'wagon', color: 'purple', direction: -1 } }],
//       'prepend',
//       false,
//       16,
//     ),
//     padRow(
//       [{ track: 'NS', vehicle: { type: 'wagon', color: 'blue', direction: -1 } }],
//       'prepend',
//       false,
//       16,
//     ),
//     padRow(
//       [{ track: 'NS', vehicle: { type: 'wagon', color: 'lawngreen', direction: -1 } }],
//       'prepend',
//       false,
//       16,
//     ),
//     padRow(
//       [{ track: 'NS', vehicle: { type: 'wagon', color: 'forestgreen', direction: -1 } }],
//       'prepend',
//       false,
//       16,
//     ),
//     padRow(['S'], 'prepend', false, 16),
//   ],
//   goal: {
//     sequence: ['lawngreen', 'forestgreen', 'blue', 'red', 'purple'],
//   },
// }
